import * as React from "react";

function SvgShowPassword(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 0a2 2 0 00-2 2v30a2 2 0 002 2h30a2 2 0 002-2V2a2 2 0 00-2-2H2zm15 7.083c-5.893 0-11.066 3.078-13.84 7.682a2.271 2.271 0 000 2.345c2.772 4.602 7.944 7.682 13.84 7.682 5.893 0 11.066-3.078 13.84-7.682a2.271 2.271 0 000-2.345C28.067 10.163 22.896 7.083 17 7.083zm6.69 8.854c0 3.618-2.993 6.545-6.69 6.545-3.698 0-6.69-2.928-6.69-6.544 0-3.618 2.993-6.545 6.69-6.545 3.698 0 6.69 2.928 6.69 6.544zM17 20.942c-2.825 0-5.116-2.24-5.116-5.005 0-2.763 2.29-5.004 5.116-5.004.871 0 1.691.213 2.409.589h-.002c-1.163 0-2.106.922-2.106 2.06s.943 2.061 2.106 2.061c1.164 0 2.107-.923 2.107-2.06v-.002c.384.702.602 1.504.602 2.357 0 2.763-2.29 5.004-5.116 5.004z"
        fill="#F7A246"
      />
    </svg>
  );
}

export default SvgShowPassword;
